import { normalizeMemory } from './characterMemory';
import type { MarketingDecisionInput } from './marketingRules';
import { evaluateMarketingRules } from './marketingRules';
import type { MarketingDecision } from './marketingTypes';

function clampTodayIndex(index: unknown): number {
  const value = typeof index === 'number' ? index : Number(index);
  if (!Number.isFinite(value)) return 1;
  return Math.max(1, Math.min(7, Math.floor(value)));
}

/**
 * Marketing Brain — 唯一回答「这一周 / 今天应不应该推广」
 *
 * 不负责素材、图片、影片、Workflow、MaterialPlan。
 */
export function buildMarketingDecision(input: MarketingDecisionInput): MarketingDecision {
  const memory = normalizeMemory({
    ...input.memory,
    characterId: input.memory.characterId,
    today_index: clampTodayIndex(input.today_index ?? input.memory.today_index),
  });

  const decision = evaluateMarketingRules(memory, input.operation);

  if (!decision.promotion_reason.length) {
    return {
      ...decision,
      promotion_reason: ['使用基础信任营销节奏，暂不推广。'],
    };
  }

  // 硬边界：禁止 high 推广强度（类型已排除，运行时再夹一次）
  if ((decision.promotion_level as string) === 'high') {
    return {
      ...decision,
      promotion_level: 'medium',
      promotion_allowed: false,
      promotion_reason: [...decision.promotion_reason, '推广强度上限为 medium，已降级。'],
    };
  }

  return decision;
}
